export function getParams (state){
    return state.params
}



// WEBPACK FOOTER //
// ./src/b2b/modules/replacement-assistant/getters.js